import { getConfig } from "../../config/localizerConfig";

const localConfig = getConfig();
const domain = localConfig.domain;

const session = {
  get: (key) => {
    const value = sessionStorage.getItem(key);
    try {
      return JSON.parse(value);
    } catch (_) {
      return value;
    }
  },
  put: ({ key, value }) => {
    sessionStorage.setItem(
      key,
      typeof value === "object" ? JSON.stringify(value) : value,
      domain
    );
  },
  remove: (key) => sessionStorage.removeItem(key),
};

export default session;
